// reCAPTCHA v3 Configuration
// Get your keys from: https://www.google.com/recaptcha/admin
export const RECAPTCHA_SITE_KEY = '6LfYFqQqAAAAANgIiN24UZqiORjlSwgeX8Y5hZGV';
export const RECAPTCHA_SECRET_KEY = '6LfYFqQqAAAAAC4Kr8UiiEDcYSZLpWTGpu1fd_vr';
